import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ValidationModule } from '@hdms/shared/util-core';

import { ButtonModule } from '../button';
import { FlyoutModule } from '../flyout/flyout.module';
import { FocusModule } from '../focus/focus.module';
import { ListboxModule } from '../listbox/listbox.module';
import { MobileModalWindowComponent } from '../mobile-modal-window/mobile-modal-window.component';
import { MobileModalWindowModule } from '../mobile-modal-window/mobile-modal-window.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

import { CheckboxComponent } from './checkbox.component';
import { FormElementComponent } from './form-element.component';
import { FormErrorsComponent } from './form-errors.component';
import { FormGroupContainerComponent } from './form-group-container.component';
import { FormGroupReadonlyDirective } from './form-group-readonly.directive';
import { FormScrollToInvalidDirective } from './form-scroll-to-invalid.directive';
import { InputExpandOnFocusDirective } from './input-expand-on-focus.directive';
import { InputExpandableFieldComponent } from './input-expandable-field.component';
import { InputFieldComponent } from './input-field.component';
import { RadiobuttonComponent } from './radiobutton.component';
import { SelectComponent } from './select.component';
import { TextareaComponent } from './textarea.component';

@NgModule({
  declarations: [
    FormScrollToInvalidDirective,
    InputFieldComponent,
    InputExpandableFieldComponent,
    InputExpandOnFocusDirective,
    TextareaComponent,
    RadiobuttonComponent,
    CheckboxComponent,
    FormElementComponent,
    FormErrorsComponent,
    FormGroupContainerComponent,
    FormGroupReadonlyDirective,
    SelectComponent
  ],
  imports: [
    ButtonModule,
    FocusModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    ValidationModule,
    FlyoutModule,
    ListboxModule,
    SvgIconModule,
    A11yModule,
    MobileModalWindowModule
  ],
  exports: [
    FormScrollToInvalidDirective,
    FormsModule,
    ReactiveFormsModule,
    InputFieldComponent,
    InputExpandableFieldComponent,
    InputExpandOnFocusDirective,
    TextareaComponent,
    RadiobuttonComponent,
    CheckboxComponent,
    FormElementComponent,
    FormGroupContainerComponent,
    FormGroupReadonlyDirective,
    SelectComponent,
    MobileModalWindowComponent,
    FormErrorsComponent
  ]
})
export class FormModule {}

export * from './checkbox.component';
export * from './form-element.component';
export * from './form-errors.component';
export * from './form-group-container.component';
export * from './form-group-readonly.directive';
export * from './form-scroll-to-invalid.directive';
export * from './input-expand-on-focus.directive';
export * from './input-expandable-field.component';
export * from './input-field.component';
export * from './radiobutton.component';
export * from './select.component';
export * from './textarea.component';
export * from './input-masked-field.component';
